<template>
  <transition name="modal">
    <div class="modal-mask" @click="close" >
      <div class="modal-wrapper">
        <div class="modal-dialog" @click.stop style="overflow-y: initial !important">
          <div class="modal-content">

            <!-- HEADER -->
            <div class="modal-header">
              <h2 class="modal-title font-bold">{{ $t("Change target") }}</h2>
              <button @click="close" type="button" class="close p-l-20 p-t-5 text-info" aria-hidden="true"><i class="ti-close"></i></button>
            </div>

            <!-- BODY -->
            <div class="modal-body">
              <p>KPI {{ name }}:</p>
              <div class="form-horizontal p-t-20">

                <div class="form-group row m-b-5">
                  <label for="target-title" class="col-sm-12 control-label">{{ $t("Target period") }}</label>
                </div>
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="input-group">
                      <select v-model="selected_target" id="target-title" class="form-control btn-rounded action-owner">
                        <option disabled value="0">{{ $t("Please select a target period") }}</option>
                        <option v-for="target in targets" :value="target.uid">Target  {{ target.date_start | dateTarget }} {{ $t("till") }}  {{ target.date_end | dateTarget }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="form-group row m-b-5">
                  <label for="target_amount" class="col-sm-12 control-label">{{ $t("Change target to") }}</label>
                </div>

                <div class="form-group row" v-bind:class="{'error' : error.length > 0}">
                  <div class="col-sm-6">
                    <input v-model="amount" id="target_amount" name="target_amount" class="form-control btn-rounded" type="text">
                    <div v-if="error.length > 0" class="help-block">
                      <ul role="alert">
                        <li><small>{{ error }}</small></li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-sm-6 text-muted">{{ units.unit }} / {{ units.period }}</div>
                </div>


                <div class="form-group row">
                  <div class="col-sm-6">
                    <button v-show="canChange && selected_target !== 0" @click="confirm_target" type="submit" class="btn btn-sm btn-rounded btn-info">{{ $t("Confirm target") }}</button>
                  </div>

                  <div class="col-sm-6 vb text-right">
                    <a @click="close" class="col-sm-6">{{ $t("Close dialog") }}</a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import apiHelper from "../mixins/APIHelper";

  export default {
    props: {
      kpi_uid: {
        default: null
      },
      kpi_name: {
        default: ''
      },
      change_able: {
        default: 0
      },
      kpi_units: {
        default: null
      }
    },
    name: "SetTargetModal",
    data: function() {
      return {
        kpi: this.kpi_uid,
        name: this.kpi_name,
        targets: [],
        selected_target: 0,
        amount: 0,
        units: this.kpi_units,
        canChange: Boolean(this.change_able),
        error: 0
      }
    },
    created() {
      this.get_target();
    },
    methods: {
      get_target: function() {
        let vm = this;

        apiHelper.getResource("/api/kpi/" + vm.kpi + "/target").then((data) => {
          vm.targets = data;
        });
      },

      confirm_target: function() {
        let vm = this;
        let data_to_send = {
          "value": vm.amount
        };

        if(isNaN(vm.amount)){
          vm.error = vm.amount.toString() + vm.$t("is not a valid number");
        }else{
          apiHelper.patchResource("/api/kpi/" + vm.kpi + "/target/" + vm.selected_target, data_to_send).then((data) => {
            vm.$notify({
              group: 'notification',
              title: vm.$t("Success"),
              text: vm.$t("Target changed successfully"),
              type: 'success'
            });
            vm.close();
          });
        }
      },

      // Close function
      close: function() {
        this.$emit('close');
      }
    },
    // So that if we press esc the modal closes
    mounted: function () {
      let vm = this;
      document.addEventListener("keydown", (event) => {
        if (event.key === 'Escape') {
          vm.close();
        }
      });
    },
    watch: {
      selected_target: function (value) {
        for (let i = 0; i < this.targets.length; i++) {
          if (this.targets[i].uid === value) {
            this.amount = this.targets[i].amount;
          }
        }
      }
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/SetTargetModal.vue